import { ButtonProps, Button as StardustButton } from "@fluentui/react-northstar";
import React from "react";

type Props = {
  tooltip?: React.ReactNode;
} & ButtonProps;

export const Button: React.FC<Props> = ({ tooltip, styles, ...buttonProps }) => {
  return <StardustButton {...buttonProps} styles={tooltip ? undefined : styles} />;
};
